<template>
  <div class="discussion-actions mt-2">
    <div class="action-buttons caption text-uppercase font-weight-medium-grey grey--text text--darken-2">
      <span
        v-if="(
          !comment.parentId
          && !comment.deleted
          && !comment.isSearchResult
          && discussionRole !== 'observer'
        )"
        :class="{
          'primary--text': show === 'reply',
        }"
        tabindex="0"
        aria-label="Reply to comment"
        role="button"
        @click="toggleReply"
        @keyup.enter="toggleReply"
      >
        Reply
      </span>
      <span
        v-if="(
          comment.replies
          && comment.replyCount
          && !comment.isSearchResult
        )"
        :class="{
          'primary--text': showReplies
        }"
        class="replies-button"
        @click="$emit('toggle-replies')"
        @keyup.enter="$emit('toggle-replies')"
        tabindex="0"
        role="button"
        :aria-label="`${showReplies ? 'Hide' : 'Show'}${comment.replyCount > 1 ? 'Replies' : 'Reply'}`"
      >
        {{showRepliesText}}
      </span>
      <span
        v-if="(
          comment.self
          && !comment.deleted
          && !comment.isSearchResult
          && discussionRole !== 'observer'
        )"
        :class="{
          'primary--text': show === 'edit'
        }"
        tabindex="0"
        aria-label="Edit Comment"
        role="button"
        @click="toggleEdit"
        @keyup.enter="toggleEdit"
      >
        Edit
      </span>
      <span
        v-if="(
          (
            comment.self
            || (
              discussionRole === 'teacher'
              && userType === 'teacher'
            )
          )
          && !comment.deleted
          && !comment.isSearchResult
          && discussionRole !== 'observer'
        )"
        :class="{
          'disabled-action': localIsProcessingData,
        }"
        tabindex="0"
        aria-label="Delete Comment"
        role="button"
        @click="deleteComment"
        @keyup.enter="deleteComment"
      >
        Delete
      </span>
    </div>
    <DiscussionInput
      v-if="(
        !comment.deleted
        && !comment.isSearchResult
        && show === 'reply'
      )"
      key="replyDiscussionInput"
      v-bubble.snackbar.error.refresh-discussion-comments.populate-comments.toggle-replies
      @toggle-reply="toggleReply"
      v-bind="$props"
      :text-model.sync="replyText"
      :interaction.sync="localInteraction"
      :is-processing-data.sync="localIsProcessingData"
      :comment="comment"
      :visible="show === 'reply'"
      mode='reply'
      placeholder="Reply to this comment"
      aria-label="Input field for editting discussion reply text."
    />
    <DiscussionInput
      v-if="(
        comment.self
        && !comment.deleted
        && !comment.isSearchResult
        && show === 'edit'
      )"
      key="editDiscussionInput"
      v-bubble.snackbar.error.refresh-discussion-comments.populate-comments.toggle-replies
      @toggle-edit="toggleEdit"
      v-bind="$props"
      :text-model.sync="editText"
      :interaction.sync="localInteraction"
      :is-processing-data.sync="localIsProcessingData"
      :comment="comment"
      :visible="show === 'edit'"
      :initial-text="initialEditText"
      mode='edit'
      placeholder="Edit this comment"
      aria-label="Input field for editting discussion reply text."
    />
  </div>
</template>

<script>
import Interaction from '../../../mixins/Interaction';
import DiscussionInput from './DiscussionInput.vue';

export default {
  name: 'DiscussionActions',
  components: {
    DiscussionInput,
  },
  mixins: [
    Interaction,
  ],
  props: {
    bulbId: Number,
    comment: {
      type: Object,
      required: true,
    },
    showReplies: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    show: null,
    editText: '',
    replyText: '',
    initialEditText: '',
  }),
  computed: {
    showRepliesText() {
      const repliesTextArray = [this.showReplies ? 'Hide' : 'Show'];
      if (
        this.comment.replyCount > this.$constants.discussionRepliesPageSize
        && !this.comment.replies.length
      ) repliesTextArray.push('first');
      if (!this.comment.replies.length) {
        repliesTextArray.push(Math.min(this.comment.replyCount, this.$constants.discussionRepliesPageSize));
      } else {
        repliesTextArray.push(this.comment.replies.length);
      }
      repliesTextArray.push(this.comment.replyCount > 1 ? ' replies' : ' reply');
      return repliesTextArray.join(' ');
    },
  },
  methods: {
    toggleEdit(bool) {
      if (typeof bool === 'boolean') this.show = bool ? 'edit' : null;
      else this.show = (this.show === 'edit') ? null : 'edit';
    },
    toggleReply(bool) {
      if (typeof bool === 'boolean') this.show = bool ? 'reply' : null;
      else this.show = (this.show === 'reply') ? null : 'reply';
    },
    deleteComment() {
      if (this.isLocalProcessingData) return false;
      if (!this.comment.replies.length) this.$emit('toggle-replies', false);
      this.$emit('delete-comment', this.comment);
      return true;
    },
  },
  watch: {
    show(n) {
      if (n === 'edit') {
        this.$set(this, 'initialEditText', this.comment.text);
      } else {
        this.$set(this, 'initialEditText', '');
      }
    },
  },
};
</script>

<style lang="scss">
.discussion-actions {
  .action-buttons {
    span {
      user-select: none;

      &:not(:first-of-type) {
        margin-left: 4px;
      }

      &.disabled-action {
        opacity: 0.6;
        pointer-events: none;
      }
    }
  }
}
</style>